<div class="modal-header">
  <h3 class="modal-title">{{$widget.data.title}}</h3>
</div>

<div class="modal-body">
  <div ng-switch="$widget.data.type">
    <div ng-switch-when="widget-pragas-vs-aplicacoes" widget-pragas-vs-aplicacoes data="$widget.data"></div>
  </div>
</div>
